import { PaypalSuccessController } from './paypal-success.controller';

export const PaypalSuccessComponent: ng.IComponentOptions = {
    template: require('./paypal-success.html'),
    controller: PaypalSuccessController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/paypal-success/paypal-success.component.ts